import cx from 'classnames';
import React, {useState} from 'react';
import dynamic from 'next/dynamic';
import {TOriginEditorProps} from "@digit-fe/digit-editor-new";
import {Spin} from "antd";
import styles from './index.module.less';
import {onFileAndVideoUpload} from './uploads';

/**
 * 打卡营后台设置富文本编辑器
 * @constructor
 */
const EditorNotSSR = dynamic(() => import('@digit-fe/digit-editor-new'), {
  ssr: false,
});
const SettingsEditor = (props: TOriginEditorProps) => {
  const root = document.getElementById('__next');
  const [loading, setLoading] = useState(true);
  const content = props?.content;
  //const parseContent = useMemo(() => {
  //  if (typeof content === 'string') {
  //    try {
  //      return JSON.parse(content);
  //    } catch (e) {
  //      return '';
  //    }
  //  }
  //  if (typeof content === 'object') {
  //    return content;
  //  }
  //  return '';
  //}, [content]);
  return (
    <>
      {loading && (<Spin tip="编辑器加载中......"/>)}
      <EditorNotSSR
        style={{display: loading ? 'none' : 'flex'}}
        placeholder="请输入"
        className={cx(styles.Editor)}
        titleProps={{showTitle: false}}
        editable
        videoProps={{
          onVideoUpload: onFileAndVideoUpload,
        }}
        mode="simple"
        imageProps={{
          onImageUpload: onFileAndVideoUpload,
        }}
        attachProps={{
          onAttachUpload: onFileAndVideoUpload,
        }}
        {...props}
        content={content}
        onLoad={() => {
          console.log('编辑器加载了');
          setLoading(false);
        }}
        fullScreenProps={{
          onEnter: () => {
            if (root) {
              root.style.overflow = 'hidden';
            }
          },
          onExit: () => {
            if (root) {
              root.style.overflow = 'auto';
            }
          }
        }}
      />
    </>
  );
};

export default SettingsEditor;
